const phdData = [
  {
    id: 1,
    name: "Kadam Sejal Ameya",
    branch: "Electronics & Telecommunication",
    registration: "42-31/05/2022",
    title:
      "Investigation of 5G massive MIMO system performance with low resolution ADC and mixed ADC architectures",
    status: "Title Approved",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 2,
    name: "Mote Hemalata Mahesh",
    branch: "Electronics & Telecommunication",
    registration: "44/01-06-2022",
    title:
      "An Optimized Framework for Image Phylogeny Tree Reconstruction",
    status: "Thesis Submitted",
    guide: "Dr. Sujata Shekhar Kulkarni",
  },
  {
    id: 3,
    name: "Paraye Milind Pandurang",
    branch: "Electronics & Telecommunication",
    registration: "46/09-06-2022",
    title:
      "Data driven impact analysis and load forecasting for Grid-connected PV power-plant",
    status: "Synopsis Submitted",
    guide: "Dr. Rajendra Govind Sutar",
  },
  {
    id: 4,
    name: "Joshi Sonia Rohit",
    branch: "Electronics & Telecommunication",
    registration: "61/23-09-2024",
    title:
      "Design and Analysis of impulse Radiating antenna",
    status: "Title Approved",
    guide: "Dr Baban U Rindhe",
  },
  {
    id: 5,
    name: "Vatkar Shilpa Naresh",
    branch: "Electronics & Telecommunication",
    registration: "52/25/04/2023",
    title:
      "Analysis of soil and crop classification using SAR images for agriculture applications",
    status: "Synopsis Submitted",
    guide: "Dr. Sujata Shekhar Kulkarni",
  },
  {
    id: 6,
    name: "Gangurde Pallavi Anil",
    branch: "Electronics & Telecommunication",
    registration: "106/ 04-09-2024",
    title:
      "Investigation of NOMA based underlay cognitive radio networks in 5G system",
    status: "Title Approved",
    guide: "Dr. Sukanya Kulkarni",
  },
  {
    id: 7,
    name: "Sagale Kaustubh Shivaji",
    branch: "Electronics & Telecommunication",
    registration: "65/12-08-2025",
    title:
      "Silent Expressions Unveiled: A Comprehensive Deep Learning Investigation into Nonverbal Vocalizations in Minimally Speaking Individuals",
    status: "Title Approved",
    guide: "Dr. Sukanya Kulkarni",
  },
  {
    id: 8,
    name: "Mahind Umesh Sarjerao",
    branch: "Electronics Engineering",
    registration: "23/11-12-2018",
    title:
      "Development of compressive sensing based iterative solution of sparse signal representation problem",
    status: "Thesis Submitted",
    guide: "Dr. Deepak Chatarabhuj Karia",
  },
  {
    id: 9,
    name: "Thakkar Rushali Ritesh",
    branch: "Electronics Engineering",
    registration: "36/15-7-2019",
    title:
      "An Investigation on reliable and efficient power electronic converters and their control for active balancing of energy cells.",
    status: "Synopsis Submitted",
    guide: "Dr. Yerramreddy Srinivasa Rao",
  },
  {
    id: 10,
    name: "Bera Aprajita S.",
    branch: "Electronics Engineering",
    registration: "37/06-07-2021",
    title:
      "Power Integrity Analysis and Design for High Speed PCB",
    status: "Thesis Submitted",
    guide: "Dr. Sudhakar Mande",
  },
  {
    id: 11,
    name: "Mane Tulshidas Ramesh",
    branch: "Electronics Engineering",
    registration: "59/07-10-2024",
    title:
      "Design a Compact Microwave Sensor For Dielectric Characterization.",
    status: "Title Approved",
    guide: "Dr. Reena Sonkusare",
  },
  {
    id: 12,
    name: "Haldankar Govind Tukaram",
    branch: "Electronics Engineering",
    registration: "62/11-03-2025",
    title:
      "Design, analysis, and performance evaluation of Permanent Magnet Machine Drives employing Plural Magnetic Materials.",
    status: "Title Approved",
    guide: "Dr. Bhalchandra N Chaudhari",
  },
  {
    id: 13,
    name: "Yeshwant Gurav Gayatri",
    branch: "Electronics & Telecommunication",
    registration: "",
    title:
      "An Image-Assisted Decision Support Framework for Material Characterization and Assessment",
    status: "Title Approved",
    guide: "Dr. Yerramreddy Srinivasa Rao",
  },
  {
    id: 14,
    name: "Balur Nazahat Jahan",
    branch: "Electronics & Telecommunication",
    registration: "",
    title:
      "Performance Analysis of Photonic Based Optical Sensor in Biomedical Applications",
    status: "Title Approved",
    guide: "Dr. Reena Sonkusare",
  },
  {
    id: 15,
    name: "Singh Riar Ishmeet",
    branch: "Electronics & Telecommunication",
    registration: "",
    title:
      "Performance Analysis of Metasurface - Based Microwave Sensor for Biomedical Application",
    status: "Title Approved",
    guide: "Dr. Reena Sonkusare",
  },
  {
    id: 16,
    name: "Kulkarni Sukanya",
    branch: "Electronics & Telecommunication",
    registration: "7/24-11-2014",
    title:
      "Efficient peak-to-average power reduction techniques for OFDM system",
    status: "Defended",
    guide: "Dr. B.K. Mishra",
  },
  {
    id: 17,
    name: "Waghmare Madhavi Harish",
    branch: "Electronics & Telecommunication",
    registration: "11/30-12-2014",
    title:
      "Enhancement of Bandwidth for broadband communication by using Photonic band gap Structure in optical fiber",
    status: "Defended",
    guide: "Dr. KTV Reddy",
  },
  {
    id: 18,
    name: "Talele Kiran Tulshiram",
    branch: "Electronics & Telecommunication",
    registration: "12/21-01-2015",
    title:
      "Emotion Recognition using facial expression",
    status: "Defended",
    guide: "Dr. Kushal Tuckley",
  },
  {
    id: 19,
    name: "Marathe Dipak Sitaram",
    branch: "Electronics & Telecommunication",
    registration: "6/17-11-2014",
    title:
      "Parameter optimization of WSN using mixed mode logic",
    status: "Defended",
    guide: "Dr. Uday Pandit",
  },
  {
    id: 20,
    name: "Banerjee Tusharika",
    branch: "Electronics & Telecommunication",
    registration: "9/27-11-2014",
    title:
      "Numerical and analytical study for Microwave generation using backward wave oscillator",
    status: "Defended",
    guide: "Dr. K T V Reddy",
  },
  {
    id: 21,
    name: "Ambawade Dayanand",
    branch: "Electronics & Telecommunication",
    registration: "14/04-03-2015",
    title:
      "Study of Event Correlation Analysis Techniques for Network Security",
    status: "Defended",
    guide: "Dr. J. W. Bakal",
  },
  {
    id: 22,
    name: "Bhagat Narendra Anant",
    branch: "Electronics & Telecommunication",
    registration: "8/25-11-2014",
    title:
      "Current mode technique for optimizing the performance of transmitter and receiver in communication system",
    status: "Defended",
    guide: "Dr. Uday Pandit",
  },
  {
    id: 23,
    name: "Sonkusare Reena S",
    branch: "Electronics & Telecommunication",
    registration: "10/23-12-2014",
    title:
      "Analysis of FinFET for analog performance and its application in analog circuit",
    status: "Defended",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 24,
    name: "Bhavarthe Pramod P",
    branch: "Electronics & Telecommunication",
    registration: "15/29-12-2016",
    title:
      "Design of Compact Electromagnetic Band Gap Structures for Enhancement of Microstrip Patch Performances",
    status: "Defended",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 25,
    name: "Sankhe Darshana Nimesh",
    branch: "Electronics & Telecommunication",
    registration: "18/18-11-2017",
    title:
      "Hardware in the Loop Test Bench for Resonant Inverter Load Characterization",
    status: "Defended",
    guide: "Dr. Yerramreddy Srinivasa Rao",
  },
  {
    id: 26,
    name: "Sawant Dattatray S.",
    branch: "Electronics & Telecommunication",
    registration: "38/02-06-2021",
    title:
      "An Investigation On Sensorless BLDC Motor Control For Solar Powered Submersible Water Pump",
    status: "Defended",
    guide: "Dr. Yerramreddy Srinivasa Rao",
  },
  {
    id: 27,
    name: "Sawant Ashwini Satish",
    branch: "Electronics & Telecommunication",
    registration: "39-02/06/2021",
    title:
      "Medical Image Enhancement and Abnormality Detection",
    status: "Defended",
    guide: "Dr. Sujata Shekhar Kulkarni",
  },
  {
    id: 28,
    name: "Rambhia Jeenal Mulchand",
    branch: "Electronics & Telecommunication",
    registration: "47/08-06-2022",
    title:
      "Brain Signal Analysis, Classification and prediction for Imagined Gestures",
    status: "Defended",
    guide: "Dr. Rajendra Govind Sutar",
  },
  {
    id: 29,
    name: "Raut Karishma Sachin",
    branch: "Electronics & Telecommunication",
    registration: "45/01-06-2022",
    title:
      "Temporal Dynamics based Real world Multimodal Affect Recognition",
    status: "Defended",
    guide: "Dr. Sujata Shekhar Kulkarni",
  },
  {
    id: 30,
    name: "Bansode Manisha Ravindra",
    branch: "Electronics Engineering",
    registration: "25/29-01-2019",
    title:
      "Design of compact electromagnetic band gap structures for high speed signaling.",
    status: "Defended",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 31,
    name: "Kapure Vijay Ramesh",
    branch: "Electronics Engineering",
    registration: "20/11-12-2018",
    title:
      "Design of Metamaterial Structure for Triple band-notch Ultra wideband Monopole Antenna",
    status: "Defended",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 32,
    name: "Keshwani Vidya Rajesh",
    branch: "Electronics Engineering",
    registration: "27/29-01-2019",
    title:
      "Design of Compact Monopole Antenna with Low Specific Absorption Rate using Metamaterial",
    status: "Defended",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 33,
    name: "Shah Payal Hitesh",
    branch: "Electronics Engineering",
    registration: "30/29-01-2019",
    title:
      "Modeling and design of silicon neurons and synapse for neuromorphic chip implementation",
    status: "Defended",
    guide: "Dr. Surendra Sardarsingh Rathod",
  },
  {
    id: 34,
    name: "Goswami Siddhant Arun",
    branch: "Electronics Engineering",
    registration: "41/09-09-2021",
    title:
      "Design and Analysis of Metamaterial Inspired Antenna for Wireless Body Area Network",
    status: "Defended",
    guide: "Dr. Deepak Chatarabhuj Karia",
  },
];

export default phdData;
